module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Contact1-38731d1af0ef2f509fd62295ebc6ebfd.svg";